import { useCallback } from 'react'

export const UNITY_SHELL_BACKGROUND = '#212629'

export function useNormalizeUnityFrameStyles(gameFrame: React.RefObject<HTMLIFrameElement | null>) {
  return useCallback(() => {
    let document: Document | null | undefined

    try {
      document = gameFrame.current?.contentDocument
    } catch {
      return
    }

    if (!document) return

    document.documentElement.style.backgroundColor = UNITY_SHELL_BACKGROUND

    if (document.body) {
      document.body.style.backgroundColor = UNITY_SHELL_BACKGROUND
    }
  }, [gameFrame])
}
